interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
  steps: string[];
}

const ProgressIndicator = ({
  currentStep,
  totalSteps,
  steps,
}: ProgressIndicatorProps) => {
  return (
    <div data-component-id="src/app/add-business/components/ProgressIndicator.tsx:13:4" data-component-path="src/app/add-business/components/ProgressIndicator.tsx" data-component-line="13" data-component-end-line="49" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20mb-8%22%7D" className="w-full mb-8">
      <div data-component-id="src/app/add-business/components/ProgressIndicator.tsx:14:6" data-component-path="src/app/add-business/components/ProgressIndicator.tsx" data-component-line="14" data-component-end-line="48" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20mb-4%22%7D" className="flex items-center justify-between mb-4">
        {steps.map((step, index) => (
          <div data-component-id="src/app/add-business/components/ProgressIndicator.tsx:16:10" data-component-path="src/app/add-business/components/ProgressIndicator.tsx" data-component-line="16" data-component-end-line="46" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20flex-1%22%7D" key={index} className="flex items-center flex-1">
            <div data-component-id="src/app/add-business/components/ProgressIndicator.tsx:17:12" data-component-path="src/app/add-business/components/ProgressIndicator.tsx" data-component-line="17" data-component-end-line="38" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20flex-1%22%7D" className="flex flex-col items-center flex-1">
              <div data-component-id="src/app/add-business/components/ProgressIndicator.tsx:18:14" data-component-path="src/app/add-business/components/ProgressIndicator.tsx" data-component-line="18" data-component-end-line="28" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                className={`w-10 h-10 rounded-full flex items-center justify-center font-cta font-bold text-sm transition-all duration-300 ${
                  index < currentStep
                    ? "bg-verification text-white"
                    : index === currentStep
                      ? "bg-brand-primary text-white"
                      : "bg-muted text-muted-foreground"
                }`}
              >
                {index < currentStep ? "✓" : index + 1}
              </div>
              <span data-component-id="src/app/add-business/components/ProgressIndicator.tsx:29:14" data-component-path="src/app/add-business/components/ProgressIndicator.tsx" data-component-line="29" data-component-end-line="37" data-component-file="ProgressIndicator.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                className={`mt-2 text-xs font-body text-center ${
                  index <= currentStep
                    ? "text-foreground font-medium"
                    : "text-muted-foreground"
                }`}
              >
                {step}
              </span>
            </div>
            {index < totalSteps - 1 && (
              <div data-component-id="src/app/add-business/components/ProgressIndicator.tsx:40:14" data-component-path="src/app/add-business/components/ProgressIndicator.tsx" data-component-line="40" data-component-end-line="44" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                className={`h-1 flex-1 mx-2 transition-all duration-300 ${
                  index < currentStep ? "bg-verification" : "bg-muted"
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;
